import type { ReactNode } from "react";

/**
 * Label/value pair for record detail sections. Keeps every module's field
 * display consistent (used inside AsideSection / RecordSection blocks).
 */
export const PropertyRow = ({
  label,
  children,
}: {
  label: string;
  children: ReactNode;
}) => (
  <div className="flex items-baseline justify-between gap-3 py-1">
    <span className="shrink-0 text-[12px] text-muted-foreground">{label}</span>
    <span className="min-w-0 truncate text-right text-[13px] text-foreground">
      {children}
    </span>
  </div>
);
